import React from 'react'
// import CV from '../../assets/cv.pdf'

const cta = () => {
  return (
    <div className='cta'>
        <a href="https://drive.google.com/drive/folders/1tyH1dd0ijx1TzRP3ppAG6gDJ_stG_HuM?usp=sharing"  className='btn'>Download CV</a>
        <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default cta